import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c(VToolbar,{attrs:{"dense":""}},[_c(VIcon,{staticClass:"mr-3"},[_vm._v(_vm._s(_vm.icon))]),_c(VToolbarTitle,[_c('span',[_vm._v(" "+_vm._s(_vm.$store.getters.translate(_vm.name)))])]),_c(VSpacer),_vm._t("actions")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }